import { MathUtils } from 'three'

export const DEFAULT_FONT_SIZE = 16
export const DEFAULT_FIXED_SIZE = 200
export const DEFAULT_GLOBAL_TEXT_SCALE = 5
export const FONT_SIZE_OPTIONS = [16, 20, 24, 32, 36, 40, 48, 64, 96, 128]
export const RELATIVE_DEFAULT_LABEL_FLAGPOLE_DISTANCE = 5 // relative to (multiplied by) text size and scale
export const MAX_FONT_SIZE = 99999

export function clampSize(newSize: number): number {
  newSize = MathUtils.clamp(newSize, 16, MAX_FONT_SIZE)
  newSize = Math.round(newSize * 10) / 10

  return newSize
}
